/**
 * SubDelegateSuccessState — accept-additional success card (plan §7.6).
 * Composes the shared InviteSignupShell. No auto-redirect — CTA back to dashboard.
 */

import { Link } from 'react-router-dom';
import { InviteSignupShell } from '@/shared/components/invite-signup';

export type SubDelegateSuccessStateProps = {
  ownerName: string;
};

export const SubDelegateSuccessState = ({
  ownerName,
}: SubDelegateSuccessStateProps) => (
  <InviteSignupShell>
    <div className="mb-8 rounded-3xl bg-white/15 p-8 text-center">
      <div className="text-5xl mb-4">✅</div>
      <h2 className="font-recoleta text-white text-3xl md:text-4xl mb-4">
        Workspace added
      </h2>
      <p className="font-termina text-white">
        You can now manage <strong>{ownerName}</strong>'s workspace. Switch to it
        from the workspace selector in the top nav whenever you need it.
      </p>
    </div>

    <div className="text-center">
      <Link
        to="/dashboard"
        className="font-termina bg-[#E2A807] font-black rounded-3xl py-3 px-6 inline-block uppercase hover:bg-[#c99006] active:scale-[0.98] transition-all duration-150"
      >
        Back to dashboard
      </Link>
    </div>
  </InviteSignupShell>
);
